import { ExternalIsaContributionType } from "../../../../../../../Wrap/Constants/Enums/Transfer/ExternalIsaContributionType";
import { TransferLocationType } from "../../../../../../../Wrap/Constants/Enums/Transfer/TransferLocationType";


export const ExternalIsaContributionTypes = [
    ExternalIsaContributionType.CurrentTaxYear,
    ExternalIsaContributionType.PreviousTaxYear,
    ExternalIsaContributionType.PreviousAndCurrentTaxYear,
];

export const ExternalIsaContributionTypesMap = {
    [ExternalIsaContributionType.CurrentTaxYear]: "Current",
    [ExternalIsaContributionType.PreviousTaxYear]: "Non-Current",
    [ExternalIsaContributionType.PreviousAndCurrentTaxYear]: "Both",
};

export const TransferLocationTypes = [
    TransferLocationType.Internal,
    TransferLocationType.External
];

export const TransferLocationTypesMap = {
    [TransferLocationType.Internal]: "Internal",
    [TransferLocationType.External]: "External",
};

export const IsaContents = {
    ToolTip_EstimatedCurrentYearSubscriptions : "The ceding provider will confirm the exact amount as part of the transfer process",
    Error_ExceedIsaAllowance : "Exceed isa allowance",
}